import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

const config = {
  types: [],
  modifiers: ['inverse'],
  states: []
}
export default function Price(props) {
  const { data, inverse, ...rest } = props

  return (
    <dl {...rest} className={resolveProps(props, config, 'Price')}>
      <dt className="mdn-Price-prefix">{data.prefix}</dt>
      <dd className="mdn-Price-price">
        {data.price}
        <span className="mdn-Price-price-period">
          {data.period ? '/' + data.period : ''}
        </span>
      </dd>
      <dd className="mdn-Price-suffix">{data.suffix}</dd>
    </dl>
  )
}

Price.propTypes = {
  data: PropTypes.shape({
    prefix: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
    period: PropTypes.string.isRequired,
    suffix: PropTypes.string.isRequired,
    inverse: PropTypes.bool
  })
}
